import React from 'react';
import $i18n from '@alife/panda-i18n';
import './index.scss';
const Head = ({ onClick, title = $i18n.get({ id: 'FeedbackTitle', dm: '反馈&建议' }), }) => {
    return (React.createElement("div", { className: 'cn-ui-intelli-header' },
        onClick ? React.createElement("span", { className: 'cn-ui-intelli-header-back', onClick: onClick }) : null,
        React.createElement("span", { className: 'cn-ui-intelli-header-title' }, title)));
};
export default Head;
